export default __webpack_public_path__ + "static/media/30.09e2e45e.png";